// FUNCTION OF LOCALSTORAGE

const localstorage = {
    addLocalstorage: (local, setLocal) => {
        localStorage.setItem(local, setLocal) 
    },

    setLocalstorage: (local) => {
        return localStorage.getItem(local)
    },

    removeLocalstorage: (local) => {
        localStorage.removeItem(local) 
    },

    allLocalstorage: () => {
        localStorage.clear()
    },
    
    validateLocal: (local1,local2,local3) => {
        return localStorage.getItem(local1) === null || localStorage.getItem(local2) === null || localStorage.getItem(local3) === null;
    }
}

export default localstorage